import './ProjectInfo.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Card } from '../../../../design/card/card/S_Cards';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { SpaceBetweenLayout } from '../../../../modules/common/layouts/spaceBetweenLayout/SpaceBetweenLayout';
import { TRAINING_VARIANT } from '../../../../modules/jobs/jobs.model';
import { EnableFor } from '../../../containers/EnableForRole';
import { toLocaleDateTimeString } from '../../../helpers/date.helpers';
import { useProjectPermissions } from '../../projects/projects.permissions';

interface IProjectInfoProps {
  createdDate: string | null;
  createdBy: string | null;
  modelVariant: TRAINING_VARIANT | null;
}

export const ProjectInfo = observer((props: IProjectInfoProps): ReactElement => {
  const { t } = useTranslator();
  const permission = useProjectPermissions();
  const { createdDate, createdBy, modelVariant } = props;

  return (
    <S_Card className='project-info'>
      <ColumnLayout size='md'>
        <div className='project-info-header'>
          <h5>{t('project_information')}</h5>
        </div>
        <ColumnLayout
          size='md'
          className='project-info-content'
        >
          <SpaceBetweenLayout>
            <div>{t('used_template')}:</div>
            <div>{t(`training_variants.${modelVariant ?? 'blank'}`)}</div>
          </SpaceBetweenLayout>
          <SpaceBetweenLayout>
            <div>{t('createdDate')}:</div>
            <div>{createdDate ? toLocaleDateTimeString(createdDate) : t('na')}</div>
          </SpaceBetweenLayout>
          <EnableFor
            hideWhenNoAccess
            hasPermission={permission.canViewCreatedBy()}
          >
            <SpaceBetweenLayout>
              <div>{t('createdBy')}:</div>
              <div>{createdBy ?? t('na')}</div>
            </SpaceBetweenLayout>
          </EnableFor>
        </ColumnLayout>
      </ColumnLayout>
    </S_Card>
  );
});
